import GeoJson from 'ol/format/GeoJSON';
import { DrawFeature, formatMeasurement } from '@agissc/ktag-map';

const useDrawMeasure = (feature: DrawFeature) => {
  const getMeasurements = () => {
    const geoJsonFeature = new GeoJson().readFeatures(feature)[0];
    const properties = geoJsonFeature.getProperties();

    if (feature.properties.type === 'text') {
      return [
        {
          key: 'measure_text',
          value: feature.properties.text,
        },
      ];
    }

    if (feature.geometry.type === 'Point') {
      const coordinates = feature.geometry.coordinates as number[];
      return [
        {
          key: 'measure_coordinates',
          value: `${coordinates.map((coord) => coord.toFixed(2)).join(', ')}`,
        },
      ];
    }

    if (feature.geometry.type === 'LineString') {
      if (feature.properties.type === 'arrow') {
        return [
          {
            key: 'measure_length',
            value: formatMeasurement(properties.length),
          },
        ];
      }

      return [
        {
          key: 'measure_size_line',
          value: formatMeasurement(properties.length),
        },
      ];
    }

    if (feature.geometry.type === 'Polygon') {
      return [
        {
          key: 'measure_size_area',
          value: formatMeasurement(properties.area, true),
        },
        {
          key: 'measure_circumference',
          value: formatMeasurement(properties.length),
        },
      ];
    }

    if (feature.properties.type === 'circle') {
      return [
        {
          key: 'measure_radius',
          value: formatMeasurement(properties.radius),
        },
        {
          key: 'measure_size_area',
          value: formatMeasurement(properties.area, true),
        },
      ];
    }

    return [];
  };

  return {
    getMeasurements,
  };
};

export default useDrawMeasure;
